import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, c = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(l, e) {
  return o(), t("svg", c, e[0] || (e[0] = [
    r("path", {
      d: "M9.99996 10.5878C9.99996 10.1217 10.3806 9.83429 11.0512 9.38634C11.6726 8.96947 12.0015 8.4309 11.8565 7.69683C11.7793 7.33178 11.5978 6.99699 11.3339 6.73315C11.0701 6.46931 10.7353 6.28777 10.3702 6.21058C10.0963 6.1596 9.81462 6.16912 9.5448 6.23848C9.27497 6.30784 9.02358 6.43536 8.80823 6.61211C8.59288 6.78885 8.41878 7.01055 8.29813 7.26166C8.17748 7.51277 8.1132 7.78723 8.10979 8.06581M9.99996 13.8244V13.5007M9.99996 18.0915C15.1785 18.0915 18.0915 15.1786 18.0915 10C18.0915 4.82143 15.1785 1.90849 9.99996 1.90849C4.82139 1.90849 1.90845 4.82143 1.90845 10C1.90845 15.1786 4.82139 18.0915 9.99996 18.0915Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const p = /* @__PURE__ */ n(s, [["render", i]]);
export {
  p as H
};
